module.exports = __webpack_public_path__ + "assets/img/page5-side-nav-neutral-5b6664c8.png";